import { UnitFieldValName } from "constant/dl_unit/dl_unit_field.constant";
import { UnitFieldInfoNames } from "type/dl_unit/dl_unit_field.type";

export function hmTitleFieldNamesGet(
  fieldValNames: UnitFieldInfoNames,
): Record<string, UnitFieldValName> {
  const hmTitleFieldNames = Object.entries(fieldValNames)
    .filter(([_, value]) => value.hm === true)
    .reduce(
      (acc, [key, value]) => {
        const title = value.hm_title!;
        // Only add if title doesn't already exist (first occurrence)
        if (!acc[title]) {
          acc[title] = key;
        }
        return acc;
      },
      {} as Record<string, string>,
    );

  return hmTitleFieldNames;
}
